import { useState, useEffect } from "react"
import logo from "../images/brand/logo.png";
import SidebarItem from "./SidebarItem";
import ConnectBar from "./ConnectBar";
import ReferralBar from "./ReferralBar";
import Settings from "./Settings";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCoins, faHome, faUsd, faSackDollar, faXmark, faHandHoldingDollar } from '@fortawesome/free-solid-svg-icons'
import { useUser } from "../utils/UserContext";
import UpgradeModal from "./UpgradeModal";
import { formatCurrency, getRate } from '../utils/currencyUtils';
import feather from 'feather-icons';
import { Link } from "react-router-dom"

function Sidebar({title, isOpen, toggleSidebar, toggleSettingsBar, settingsBar }) {
  const currentPath = window.location.pathname;
  useEffect(() => {
    feather.replace();
  }, []);
  const { user } = useUser();
  const [referralBar, setReferralBar] = useState(false);
  const [connectBar, setConnectBar] = useState(false);
  const toggleReferralBar = () => {
    setReferralBar(!referralBar);
  };
  const toggleConnectBar = () => {
    setConnectBar(!connectBar);
  };
  useEffect(() => {
    if (window.innerWidth >= 768) {
      toggleSidebar(true);
    }
  }, []);
  const [rate, setRate] = useState(1);
    const currencyCode = user?.currency;
    useEffect(() => {
      let isMounted = true;
      const fetchRate = async () => {
        const r = await getRate(currencyCode);
        if (isMounted) setRate(r);
      };
      fetchRate();
      return () => { isMounted = false; };
    }, [currencyCode]);
    const logout = () => {
      fetch(`${process.env.REACT_APP_API_URL}controller/logout.php`, {
        credentials: "include",
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({ logout: true})
      })
      .then(response => response.text())
      .then(data => {
        if (data === "success") {
          window.location.href = "login";
        }
      })
      .catch(err => {
        console.error(err)
      }) 
    };
    return (
      <>
        <div className={`col-auto sidebar ${window.innerWidth < 768 ? "mobilesidebar" : ""} ${isOpen ? "active" : ""}`}style={{ display: "block" }}>
          <img src={logo} alt="logo" className="app-logo mb-3" style={{paddingLeft:'16px',paddingRight:'16px'}}/>
          <div className="d-flex align-items-center justify-content-center rounded-circle position-absolute d-block d-md-none" style={{width:'30px',height:'30px', top:'15px',right:'20px',backgroundColor:'#ffffff0d'}} onClick={toggleSidebar}>
            <FontAwesomeIcon icon={faXmark} style={{color: 'gray', cursor: 'pointer', fontSize: '22px'}}/>
          </div>
          <div className="py-3 w-100" style={{backgroundColor:'#0a0b0c', paddingLeft:'16px',paddingRight:'16px'}}>
            <p className="text-secondary fw-semibold mb-0" style={{fontSize:'12px'}}>MAIN ACCOUNT BALANCE</p>
            <div className="d-flex align-items-top justify-content-between">
              <div>
                <div className="d-flex align-items-end">
                  <p className="fs-2 fw-semibold text-prime mb-0 lh-1">{formatCurrency(Number(user?.balance) * rate)}</p>
                  <p className="fs-6 ms-3 text-white fw-semibold mb-0">{user?.currency}</p>
                </div>
                <p className="mb-0 fw-semibold text-white" style={{fontSize:'14px'}}>{formatCurrency(Number(user?.balance) * rate)} {user?.currency}</p>
              </div>
              <i data-feather="log-out" className="text-prime" style={{cursor:'pointer'}} width="20" onClick={logout}></i>
            </div>  
            <hr/>
            <div className="d-flex align-items-center justify-content-between mb-2">
              <p className="text-secondary mb-0" style={{fontSize:'14px'}}>Profit (All)</p>
              <p className="fw-semibold mb-0" style={{fontSize:'14px'}}><span className="text-prime">{formatCurrency(user?.savings_gain * rate)}</span> {user?.currency}</p>
            </div>
            <div className="d-flex align-items-center justify-content-between mb-2">
              <p className="text-secondary mb-0" style={{fontSize:'14px'}}>Total Deposits</p>
              <p className="fw-semibold mb-0" style={{fontSize:'14px'}}><span className="text-prime">{formatCurrency(user?.total_deposit * rate)}</span> {user?.currency}</p>
            </div>
            <div className="d-flex align-items-center justify-content-between">
              <p className="text-secondary mb-0" style={{fontSize:'14px'}}>Total Withdraws</p>
              <p className="fw-semibold mb-0" style={{fontSize:'14px'}}><span className="text-prime">{formatCurrency(user?.total_withdraw * rate)}</span> {user?.currency}</p>
            </div>
            <div className="d-flex align-items-center justify-content-between mt-3">
              <Link to="/deposit" className="py-2 d-flex justify-content-center rounded-pill" style={{border: '2px solid #ff6b35',backgroundColor:'transparent', textDecoration:'none',width:'47%'}}>
                <p className="mb-0 fw-semibold text-prime" style={{fontSize: '12px'}}>DEPOSIT</p>
              </Link>
              <Link to="/withdraw" className="d-flex justify-content-center rounded-pill bg-prime" style={{textDecoration:'none', paddingTop:'10px',paddingBottom:'10px',width:'47%'}}>
                <p className="mb-0 fw-semibold" style={{fontSize: '12px'}}>WITHDRAW</p>
              </Link>
            </div>
          </div>
          <div className="sidebar-navbar" style={{marginTop:'10px',paddingLeft:'16px',paddingRight:'16px'}}>
            <p className="mb-0 fw-bold text-white" style={{fontSize:'14px'}}>Account</p>
            <SidebarItem icon={<i data-feather="home" height="18"></i>} label="Dashboard" isActive={(title === "Dashboard")?true:false} link="/dashboard" />
            <SidebarItem icon={<i data-feather="credit-card" height="18"></i>} label="Deposit" isActive={(title === "Deposit")?true:false} link="/deposit" />
            <SidebarItem icon={<i data-feather="package" height="18"></i>} label="Withdraw" isActive={(title === "Withdraw")?true:false} link="/withdraw" />
            {/* <SidebarItem icon={<i data-feather="send" height="18"></i>} label="Swap" isActive={(title === "Swap")?true:false} link="/transfer" />
            <SidebarItem icon={<i data-feather="grid" height="18"></i>} label="Assets" isActive={(title === "Assets")?true:false} link="/assets" /> */}
            <SidebarItem icon={<i data-feather="layers" height="18"></i>} label="Stock" isActive={(title === "Stock")?true:false} link="/stock" />
            <p className="mb-0 fw-bold text-white mt-2" style={{fontSize:'14px'}}>Settings</p>
            <SidebarItem icon={<i data-feather="link" height="18"></i>} label="Connect wallet" isActive={(title === "Connect wallet")?true:false} onClick={() => {toggleConnectBar()}}  />
            <SidebarItem icon={<i data-feather="settings" height="18"></i>} label="Settings" isActive={(title === "Settings")?true:false} onClick={() => {toggleSettingsBar()}} />
            {user?.user_type === "adminface" && (
              <SidebarItem icon={<i data-feather="user-check" height="18"></i>} label="Admin" isActive={(title === "Admin")?true:false} />
            )}
          </div>
        </div>
        <UpgradeModal UserDetails={user} currentPath={currentPath} />
        <ReferralBar toggleReferralBar={toggleReferralBar} referralBar={referralBar}/>
        <ConnectBar toggleConnectBar={toggleConnectBar} connectBar={connectBar}/>
        <Settings toggleSettingsBar={toggleSettingsBar} settingsBar={settingsBar}/>
      </>
    )
}

export default Sidebar